/* eslint-disable @typescript-eslint/no-explicit-any */

import { supplierInquiryStatusEnum } from '@/global/enum'
import { cn } from '@xhgj/xh-jsutils'

export interface StatusTagProps {
  status?: string
  enumType?: 'inquiry'
}

export default function InquiryStatusAdminTag(props: StatusTagProps) {
  const { enumType = 'inquiry', status } = props
  const enumArr = supplierInquiryStatusEnum
  const item = enumArr.find((item: any) => item.value === status)
  return (
    <>
      {status && (
        <div
          className={cn(
            enumArr.getAttrByValue(item?.value as any, 'tagClassName'),
            'leading-0 px-[5px] flex items-center',
          )}
        >
          {item?.label}
        </div>
      )}
    </>
  )
}
/* eslint-disable @typescript-eslint/no-explicit-any */

import { supplierInquiryStatusEnum } from '@/global/enum'
import { cn } from '@xhgj/xh-jsutils'

export interface StatusTagProps {
  status?: string
  enumType?: 'inquiry'
}

export default function InquiryStatusAdminTag(props: StatusTagProps) {
  const { enumType = 'inquiry', status } = props
  const enumArr = supplierInquiryStatusEnum
  const item = enumArr.find((item: any) => item.value === status)
  return (
    <>
      {status && (
        <div
          className={cn(
            enumArr.getAttrByValue(item?.value as any, 'tagClassName'),
            'leading-0 px-[5px] flex items-center',
          )}
        >
          {item?.label}
        </div>
      )}
    </>
  )
}
